import * as React from 'react';
import Estimations from '../../domain/estimations/Estimations';
import { calculateSeparatorForMonths } from '../estimations/calculateSeparatorForMonths';
import { NavLink } from 'react-router-dom';

interface Props {
    placedEstimations: Estimations;
}

class PopupEstimationsPlaced extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <>
                <div className="popup-title">Thank you for your estimation!</div>
                <div className="popup-text">Your estimation has been placed successfully</div>
                <div className="popup-text">
                    The estimation will be divided into one order per month for the following months
                    <div className="bold">
                        {calculateSeparatorForMonths(this.props.placedEstimations!).map((text, index) => {
                            return <span key={index}>{text}</span>;
                        })}
                    </div>
                    <div className="popup-button">
                        <NavLink className="link-button" to="/estimations-history">
                            See estimation details >
                        </NavLink>
                    </div>
                </div>
            </>
        );
    }
}

export default PopupEstimationsPlaced;



// WEBPACK FOOTER //
// ./src/view/popup/PopupEstimationsPlaced.tsx